import log from 'salvo-lite/log'

class AjaxCart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._cartCount = elem.querySelector('[data-cart-count]')
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)

        document.addEventListener('cartRetreived', (e) => {
            this._cartCount.dataset.cartCount = e.detail.item_count
        })

        document.addEventListener('cartUpdated', (e) => {
            this._cartCount.dataset.cartCount = e.detail.item_count
        })
    }
}

export default AjaxCart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/AjaxCart.js